var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 60,
    viewBox: "0 0 223 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_2527_8706)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 219,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_2527_8706)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.35135,
    y: 1.35135,
    width: 220.297,
    height: 57.2973,
    rx: 28.6486,
    stroke: "url(#paint1_linear_2527_8706)",
    strokeOpacity: 0.08,
    strokeWidth: 1.2973
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.182 44.9459H61.7639C61.7639 41.5359 60.4886 38.5545 57.94 36.0059C55.3915 33.4573 52.4122 32.182 49 32.182V31.7639C52.4122 31.7639 55.3915 30.4886 57.94 27.9337C60.4886 25.3788 61.7639 22.3995 61.7639 19H62.182C62.182 22.4101 63.4574 25.3915 66.0059 27.94C68.5545 30.4886 71.5338 31.7639 74.9459 31.7639V32.182C71.5359 32.182 68.5545 33.4573 66.0059 36.0059C63.4574 38.5545 62.182 41.5338 62.182 44.9459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8778 30.6757H80.6897C80.6897 29.1412 80.1158 27.7995 78.9689 26.6527C77.8221 25.5058 76.4814 24.9319 74.9459 24.9319V24.7438C76.4814 24.7438 77.8221 24.1699 78.9689 23.0202C80.1158 21.8705 80.6897 20.5298 80.6897 19H80.8778C80.8778 20.5345 81.4517 21.8762 82.5986 23.023C83.7454 24.1699 85.0861 24.7438 86.6216 24.7438V24.9319C85.0871 24.9319 83.7454 25.5058 82.5986 26.6527C81.4517 27.7995 80.8778 29.1402 80.8778 30.6757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4 32.98V32.26H93.3V32.98C93.3 34.4 94.08 35.42 95.68 35.42C97.32 35.42 98.04 34.42 98.04 32.92V22.54H100V33C100 35.6 98.26 37.24 95.68 37.24C92.92 37.24 91.4 35.48 91.4 32.98ZM102.106 32.1C102.106 29.08 104.266 26.96 107.206 26.96C110.126 26.96 112.286 29.08 112.286 32.1C112.286 35.12 110.126 37.24 107.206 37.24C104.266 37.24 102.106 35.12 102.106 32.1ZM104.006 32.1C104.006 34.14 105.306 35.56 107.206 35.56C109.086 35.56 110.406 34.14 110.406 32.1C110.406 30.06 109.086 28.64 107.206 28.64C105.306 28.64 104.006 30.06 104.006 32.1ZM115.087 24.9C114.407 24.9 113.847 24.34 113.847 23.66C113.847 22.96 114.407 22.42 115.087 22.42C115.767 22.42 116.327 22.96 116.327 23.66C116.327 24.34 115.767 24.9 115.087 24.9ZM114.167 37V27.22H116.047V37H114.167ZM120.456 37H118.576V27.22H120.276L120.476 28.72C121.096 27.6 122.336 26.94 123.716 26.94C126.296 26.94 127.476 28.52 127.476 31.02V37H125.596V31.44C125.596 29.46 124.676 28.66 123.236 28.66C121.476 28.66 120.456 29.92 120.456 31.82V37ZM137.429 37H135.469V22.54H137.429L144.829 33.72V22.54H146.789V37H144.829L137.429 25.82V37ZM148.997 32.1C148.997 29.08 151.157 26.96 154.097 26.96C157.017 26.96 159.177 29.08 159.177 32.1C159.177 35.12 157.017 37.24 154.097 37.24C151.157 37.24 148.997 35.12 148.997 32.1ZM150.897 32.1C150.897 34.14 152.197 35.56 154.097 35.56C155.977 35.56 157.297 34.14 157.297 32.1C157.297 30.06 155.977 28.64 154.097 28.64C152.197 28.64 150.897 30.06 150.897 32.1ZM162.708 37L159.508 27.22H161.448L163.068 32.3C163.288 33.02 163.488 33.76 163.668 34.62C163.828 33.76 164.088 32.94 164.308 32.3L165.948 27.22H167.868L169.488 32.3C169.648 32.78 169.968 33.92 170.128 34.62C170.288 33.84 170.468 33.16 170.748 32.3L172.388 27.22H174.348L171.008 37H169.228L167.528 31.76C167.208 30.78 167.008 30.02 166.908 29.48C166.808 29.96 166.628 30.6 166.268 31.78L164.568 37H162.708Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_2527_8706",
    x: 0.702698,
    y: -30.4325,
    width: 221.595,
    height: 100.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20.7568,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2527_8706"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3784
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_2527_8706"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -31.1351
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.7568
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2527_8706",
    result: "effect2_innerShadow_2527_8706"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.78378
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2527_8706",
    result: "effect3_innerShadow_2527_8706"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2527_8706",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.5 30) scale(109.5 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2527_8706",
    x1: 2,
    y1: 30,
    x2: 221,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250099"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinButton);
export default __webpack_public_path__ + "static/media/joinButton.0c6606378064665caa7e3b666a45bb96.svg";
export { ForwardRef as ReactComponent };